import { Footer } from "./Footer.styled";

export function FooterApp(){
  return (
    <Footer>
      <p>© 2023 by Volodymyr</p>
    </Footer>
  )
};